'use client';

import dynamic from 'next/dynamic';

export const BrowserUsageTable = dynamic(
  () => import('./BrowserUsageTable')
);
export const OverflowDemo = dynamic(() => import('./OverflowDemo'));
export const OverflowDemoWithSubsequentContent = dynamic(
  () => import('./OverflowDemoWithSubsequentContent')
);
